import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Form, Field, reduxForm, getFormSyncErrors } from 'redux-form';
import trans from 'counterpart';
// import validate from '../../modules/reservation/validate';
import CheckboxField from '../../modules/form/components/CheckboxField';
import TextField from '../../modules/form/components/TextField';
import TextareaField from '../../modules/form/components/TextareaField';
import RadioButtonsField from '../../modules/form/components/RadioButtonsField';
import SelectField from '../../modules/form/components/SelectField';
import CheckboxGroup from './fields/CheckboxGroup';

const isRequired = value => (value || typeof value === 'number' ? undefined : trans('form.field_mandatory'));
const isValidEmail = value => value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
  ? trans('form.field_email_invalid')
  : undefined;

class SymfonyForm extends Component {
  state = {
    message: null
  }

  componentDidUpdate = (prevProps) => {
    if (!prevProps.invalid && this.props.invalid && this.props.form === 'customer' && this.props.triggerSubmit) {
      this.props.touch(this.props.form, ...Object.keys(this.props.formSyncErrors));
    }
  }

  getCSRFToken = () => this.props.formDefinition.properties._token && this.props.formDefinition.properties._token.value

  isRemoteForm = () => this.props.block.form && this.props.block.form.id;

  submitForm = (values) => {
    if (this.state.message) {
      this.setState({ message: null });
    }

    this.props.onSubmit({ ...values, _token: this.getCSRFToken() });
  }

  renderField = (name) => {
    if (name === '_token') return null;
    const field = this.props.formDefinition.properties[name];
    const required = this.props.formDefinition.required.includes(name);
    const placeholder = (field.attr || {}).placeholder; // eslint-disable-line prefer-destructuring

    if (field.items) {
      const options = field.items;
      if (field.type === 'array') {
        return (
          <Field
            key={name}
            name={name}
            component={CheckboxGroup}
            label={field.title}
            validate={required ? isRequired : undefined}
            required={required}
            options={options.enum.map((id, i) => ({
              key: id,
              value: options.enum_titles[i]
            }))}
          />
        );
      }

      return (
        <Field
          key={name}
          name={name}
          component={RadioButtonsField}
          label={field.title}
          validate={required ? isRequired : undefined}
          required={required}
          options={options.enum.map((id, i) => ({
            key: id,
            value: options.enum_titles[i]
          }))}
        />
      );
    }

    if (field.enum) {
      return (
        <Field
          key={name}
          name={name}
          component={SelectField}
          label={field.title}
          validate={required ? isRequired : undefined}
          required={required}
          options={field.enum.map((id, i) => ({
            key: id,
            value: field.enum_titles[i]
          }))}
        />
      );
    }

    if (field.properties && field.properties.value) {
      switch (field.properties.value.widget) {
        case 'textarea': {
          return (
            <Field
              key={name}
              name={name}
              component={TextareaField}
              label={field.title}
              validate={required ? isRequired : undefined}
              required={required}
            />
          );
        }
        default: {
          const validators = [];
          if (required) validators.push(isRequired);
          if (field.properties.value.widget === 'email') validators.push(isValidEmail);
          return (
            <Field
              key={name}
              name={name}
              type={field.properties.value.widget}
              component={TextField}
              label={field.title}
              validate={validators}
              required={required}
            />
          );
        }
      }
    }

    return (
      <Field
        key={name}
        name={name}
        component={TextField}
        label={field.title}
        validate={required ? isRequired : undefined}
        required={required}
        placeholder={placeholder ? trans(placeholder) : undefined}
      />
    );
  }

  render = () => {
    const { pristine, handleSubmit, submitting } = this.props;

    return (
      <Fragment>
        <Form
          onSubmit={handleSubmit(this.submitForm)}
          className="contact-form form-horizontal"
        >
          {Object.keys(this.props.formDefinition.properties).map(field => this.renderField(field))}
          <div className="form-group row">
            <div className="col-md-12 pointer-events">
              <span className="req">
                <bdi>*</bdi>
                {trans('form.fields_required')}
              </span>
              <button
                type="submit"
                id="form-send"
                className={`btn btn-send btn-lg btn-orange btn-submit ${pristine || submitting || this.state.message === 'Success' ? 'disabled' : ''}`}
                disabled={pristine || submitting || this.state.message === 'Success'}
              >
                {trans('button.submit')}
              </button>
            </div>
          </div>
        </Form>
        {this.state.message === 'Success' && (
          <div className="success-message-style">
            Bedankt! Wij hebben het formulier ontvangen.
          </div>
        )}
      </Fragment>
    );
  }
}

SymfonyForm.propTypes = {
  block: PropTypes.object,
  formDefinition: PropTypes.object,
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  touch: PropTypes.func,
  triggerSubmit: PropTypes.bool,
  formSyncErrors: PropTypes.object,
  invalid: PropTypes.bool,
  form: PropTypes.string
};

const mapStateToProps = (state, ownProps) => ({
  form: ownProps.name || 'default',
  formSyncErrors: getFormSyncErrors(ownProps.name || 'default')(state)
});

export default compose(
  connect(mapStateToProps),
  reduxForm({
    destroyOnUnmount: false,
    enableReinitialize: true,
    // validate,
    onSubmit: () => {
      // This prop needs to be added to support remote validation by triggering redux-form's `submit` action.
      // TODO: Allow defining a custom onSubmit action from CMS.
    },
  })
)(SymfonyForm);
